/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LoadingPageText from '../../common/Loading/LoadingPageText';
import { useFetchAuditEventDetails } from '../../../actions/areas/admin/fetchHooks/fetchAudit';
import PatientDetails from '../../Planner/ClinicianView/AssignmentDetails/PatientDetails';
import ActivityDetails from './EventDetails/ActivityDetails';
import PostingDetails from './EventDetails/PostingDetails';
import AssignmentDetails from './EventDetails/AssignmentDetails';
import ReferralDetails from './EventDetails/ReferralDetails';
import ReasonDetails from './EventDetails/ReasonDetails';
import PatternConfigurationDetails from './EventDetails/PatternConfigurationDetails';
import ReferralRelatedEntityDetails from './EventDetails/ReferralRelatedEntityDetails';
import ClinicianMileageCapDetails from './EventDetails/ClinicianMileageCapDetails';
import TreatmentInstanceDetails from './EventDetails/TreatmentInstanceDetails';
import TreatmentDetails from '../../Planner/ClinicianView/UnassignedTreatments/TreatmentDetails';
import AuditProperties from './EventDetails/AuditProperties';
import NonPatientActivityDetails from './EventDetails/NonPatientActivityDetails';
import _ from '../../../utils/lodash';

export default function AuditDetailsSidePanel({ eventEntry, events }) {
  const [state, setState] = useState({ tab: 0 });
  const { data, isDataLoading } = useFetchAuditEventDetails(eventEntry.entryId, false);

  const items = data.eventEntry;
  const locale = events.locale;
  const asArray = data.eventEntry && Object.entries(data.eventEntry);

  const createTabs = () => {
    const tabs = [];
    let i = 0;
    for (const [key, value] of asArray) {
      if (!_.isEmpty(value) && key !== 'treatmentPatternTimeSlot') {
        tabs.push({ key: i, name: key.replace(/([A-Z])/g, ' $1').trim() });
        i++;
      }
    }
    return tabs;
  };

  const tabs = items && createTabs();

  let nonPatientActivityAudit;
  if (items !== undefined && items.nonPatientActivity != null) {
    nonPatientActivityAudit =
      items.nonPatientActivity.length > 1 ? items.nonPatientActivity[1] : items.nonPatientActivity[0];
  }

  const handleChange = (event, value) => {
    setState({ ...state, tab: value, tabName: event.target.textContent });
  };

  const headerRender = () => {
    return (
      <div className="sidePanel-header card-status-green">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">{locale.getMsg('auditDetails')}</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => events.onClose()}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
        <div className="sidePanel-header-wrapper">
          <div className="sidePanel-header-left-info-wrap">
            <div className="sidePanel-header-title">
              <Typography variant="h2" gutterBottom>
                {eventEntry.type}
              </Typography>
              <Typography variant="h5">
                {events.generateDescription(eventEntry.description, eventEntry.properties)}
              </Typography>
            </div>
            <div className="sidePanel-header-info patient-header">
              <Box className="assignment-desc-info" display="flex" flexDirection="row">
                <Box display="flex" flexDirection="row">
                  <Box className="header-icon-wrapper">
                    <Badge className="clinician-badge" color="error">
                      <span className="icon-extend icon-medic" />
                      <span className="info-text">{eventEntry.user}</span>
                    </Badge>
                  </Box>
                  <Box className="header-icon-wrapper">
                    <AccessTimeIcon />
                    <span className="info-text"> {eventEntry.dateCreated}</span>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEntityContent = tabName => {
    return tabs.find(x => x.key === state.tab && x.name === tabName);
  };

  const renderAuditProps = props => {
    return <AuditProperties props={props} />;
  };

  const auditEntryDetailsRender = () => {
    return (
      <React.Fragment>
        <div className="sidePanel-content">
          <Grid container spacing={0}>
            <Grid item xs={12}>
              {tabs !== undefined && tabs.length > 1 && (
                <Tabs
                  className="custom-tabs"
                  value={state.tab}
                  onChange={handleChange}
                  centered={tabs.length <= 3}
                  variant={tabs.length > 3 ? 'scrollable' : 'standard'}
                >
                  {items && tabs.length > 1 && tabs.map(x => <Tab label={x.name} key={`tab_${x.name}`} />)}
                </Tabs>
              )}
              {tabs === undefined ||
                (tabs.length < 1 && (
                  <p style={{ textAlign: 'center', paddingTop: '10px' }}>
                    There are no details for this event entry or database auditing is not enabled
                  </p>
                ))}
            </Grid>
            {items !== undefined && (
              <Grid item xs={12}>
                {items.patient !== null && renderEntityContent('patient') && (
                  <div className="clinician-info-box">
                    <Box>
                      <Typography variant="h6" gutterBottom>
                        Patient details
                      </Typography>
                      <PatientDetails patientDetails={items.patient} />
                    </Box>
                  </div>
                )}
                {items.treatment !== null && renderEntityContent('treatment') && (
                  <Box>
                    <TreatmentDetails
                      treatment={items.treatment[0]}
                      canEdit
                      includeTreatments
                      refreshGrid={false}
                      isAuditDetailsRender
                    />
                    {data.isAuditEnabled &&
                      items.treatment[0].auditEntryProperties &&
                      renderAuditProps(items.treatment[0].auditEntryProperties)}
                  </Box>
                )}
                {items.activity != null && renderEntityContent('activity') && (
                  <Box>
                    <ActivityDetails activities={items.activity} />
                  </Box>
                )}
                {items.assignment != null && renderEntityContent('assignment') && (
                  <Box>
                    <AssignmentDetails assignment={items.assignment[0]} />
                    {data.isAuditEnabled &&
                      items.assignment[0].auditEntryProperties &&
                      renderAuditProps(items.assignment[0].auditEntryProperties)}
                  </Box>
                )}
                {items.posting != null && renderEntityContent('posting') && (
                  <Box>
                    <PostingDetails posting={items.posting[0]} />
                    {data.isAuditEnabled &&
                      items.posting[0].auditEntryProperties &&
                      renderAuditProps(items.posting[0].auditEntryProperties)}
                  </Box>
                )}
                {items.obsoletionReason != null && renderEntityContent('obsoletion Reason') && (
                  <Box>
                    <ReasonDetails reason={items.obsoletionReason[0]} />
                    {data.isAuditEnabled &&
                      items.obsoletionReason[0].auditEntryProperties &&
                      renderAuditProps(items.obsoletionReason[0].auditEntryProperties)}
                  </Box>
                )}
                {items.referral != null && renderEntityContent('referral') && (
                  <Box>
                    <ReferralDetails referral={items.referral[0]} />
                    {data.isAuditEnabled &&
                      items.referral[0].auditEntryProperties &&
                      renderAuditProps(items.referral[0].auditEntryProperties)}
                  </Box>
                )}
                {items.treatmentInstance != null && renderEntityContent('treatment Instance') && (
                  <Box>
                    <TreatmentInstanceDetails instances={items.treatmentInstance} />
                  </Box>
                )}
                {items.clinicianMileageCap != null && renderEntityContent('clinician Mileage Cap') && (
                  <Box>
                    <ClinicianMileageCapDetails mileageCaps={items.clinicianMileageCap} />
                  </Box>
                )}
                {items.referralService != null && renderEntityContent('referral Service') && (
                  <Box>
                    <ReferralRelatedEntityDetails
                      entity={items.referralService[0]}
                      entityName={'Referral Service'}
                      isService
                    />
                    {data.isAuditEnabled &&
                      items.referralService[0].auditEntryProperties &&
                      renderAuditProps(items.referralService[0].auditEntryProperties)}
                  </Box>
                )}
                {items.referralSource != null && renderEntityContent('referral Source') && (
                  <Box>
                    <ReferralRelatedEntityDetails
                      entity={items.referralSource[0]}
                      entityName={'Referral Source'}
                      false
                    />
                    {data.isAuditEnabled &&
                      items.referralSource[0].auditEntryProperties &&
                      renderAuditProps(items.referralSource[0].auditEntryProperties)}
                  </Box>
                )}
                {items.referralPriority != null && renderEntityContent('referral Priority') && (
                  <Box>
                    <ReferralRelatedEntityDetails
                      entity={items.referralPriority[0]}
                      entityName={'Referral Priority'}
                      false
                    />
                    {data.isAuditEnabled &&
                      items.referralPriority[0].auditEntryProperties &&
                      renderAuditProps(items.referralPriority[0].auditEntryProperties)}
                  </Box>
                )}
                {items.treatmentPatternConfiguration != null && renderEntityContent('treatment Pattern Configuration') && (
                  <Box>
                    <PatternConfigurationDetails patterns={items.treatmentPatternConfiguration} />
                  </Box>
                )}
                {items.nonPatientActivity != null && renderEntityContent('non Patient Activity') && (
                  <Box>
                    <NonPatientActivityDetails nonPatientActivity={nonPatientActivityAudit} />
                    {data.isAuditEnabled &&
                      nonPatientActivityAudit.auditEntryProperties &&
                      renderAuditProps(nonPatientActivityAudit.auditEntryProperties)}
                  </Box>
                )}
              </Grid>
            )}
          </Grid>
        </div>
        {data.length > 0 && !data.isAuditEnabled && (
          <div>
            <p style={{ textAlign: 'center', paddingTop: '10px' }}> Database Auditing is not enabled</p>
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <section className="side-panel-content-wrapper">
        <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
          <div className="sidePanel-wrapper" style={{ width: '635px' }} id="unassigned-side-panel">
            {headerRender()}
            {!isDataLoading && data != null ? (
              auditEntryDetailsRender()
            ) : (
              <LoadingPageText showHeader={false}>Wait a moment while we gather audit entry details...</LoadingPageText>
            )}
          </div>
        </SwipeableDrawer>
      </section>
    </React.Fragment>
  );
}
